import { z } from 'zod';

const envSchema = z.object({
  REACT_APP_API_URL: z.url(),
  REACT_APP_PERMISSIONS_URL: z.url(),
});

function parseEnv() {
  try {
    const envs = {
      REACT_APP_API_URL: process.env.REACT_APP_API_URL,
      REACT_APP_PERMISSIONS_URL: process.env.REACT_APP_PERMISSIONS_URL,
    };
    const result = envSchema.parse(envs);
    return result;
  } catch (error) {
    console.error('Loading environment variables failed:');
    if (error instanceof z.ZodError) {
      Object.keys(z.treeifyError(error).properties).forEach(key => {
        console.error(
          'Environment Variable: ',
          key,
          z.treeifyError(error).properties[key].errors
        );
      });
    } else {
      console.error('Unexpected error:', error);
    }
  }
}

export const ENV = parseEnv();
